import {connect} from 'react-redux'
import Outreach from '../components/Outreach/Outreach'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(Outreach)


// WEBPACK FOOTER //
// ./src/containers/Outreach.js